import FJImageExtenderData from '../../config/dataConfig/FJImageExtenderData';
import FJConfig from '../../config/FJConfig';
import FJS3Config from '../../config/FJS3Config';
import FJConstant from '../../constants/FJConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    IMAGE_EXTENDER_USE_CREDIT,
    setSliceBoardSize,
    setSliceCurRatioName,
    setSliceGenerateNumber,
    setSliceImageRect,
    setSliceUploadImageInfo,
} from '../slices/FJSliceImageExtender';
import { setSliceIsShowPresetImageBox } from '../slices/FJSliceTextToImage';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import FJFileHandleUtil from '../../util/FJFileHandleUtil';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';

const MIN_IMAGE_SIZE = 50;

let f_startGenerateTime = null;

const FJActionImageExtender = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageInfo({}));
            // dispatch(setSliceGenerateNumber(1));
            // dispatch(setSliceCurRatioName('original'));
        };
    },
    uploadImageAction: function (file, skipTranscoded = false) {
        return async dispatch => {
            const isGIF = await FJUtil.isGIF(file);
            if (isGIF) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }

            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            if (!isImage) {
                if (skipTranscoded) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    return;
                }
            }
            const data = await FJCompressedImageStore.compressImageByFile(file);
            if (data) {
                if (data.height < MIN_IMAGE_SIZE || data.width < MIN_IMAGE_SIZE) {
                    FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-image-size-min'), 'error');
                    return;
                }
                dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
                dispatch(setSliceUploadImageInfo({ ...data }));
                dispatch(this._fitBoardSizeByCurRatioAction());
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async dispatch => {
            const { size, name, id } = options;
            let data;
            if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            if (data) {
                if (data.height < MIN_IMAGE_SIZE || data.width < MIN_IMAGE_SIZE) {
                    FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-image-size-min'), 'error');
                    return;
                }
                dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
                dispatch(setSliceUploadImageInfo(data));
                dispatch(this._fitBoardSizeByCurRatioAction());
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @desc 根据当前比例计算画布大小、图片大小
     * @returns
     */
    _fitBoardSizeByCurRatioAction: function () {
        return async (dispatch, getState) => {
            const { uploadImageInfo } = getState().imageExtender;

            const curBoardRatioName = getState().imageExtender.curRatioName;
            const imageRatio = uploadImageInfo.width / uploadImageInfo.height;

            const curBoardRatio =
                curBoardRatioName === 'original'
                    ? imageRatio
                    : FJImageExtenderData.RATIO_LIST.find(item => item.name === curBoardRatioName)?.value;

            let newImageRect = { width: uploadImageInfo.width, height: uploadImageInfo.height };
            // 原图的最长边
            const maxDistance = Math.max(uploadImageInfo.width, uploadImageInfo.height);

            const newBoardSize = {
                width: curBoardRatio >= 1 ? maxDistance : Math.floor(maxDistance * curBoardRatio),
                height: curBoardRatio >= 1 ? Math.floor(maxDistance / curBoardRatio) : maxDistance,
            };

            if (curBoardRatioName === 'original') {
                newBoardSize.width = uploadImageInfo.width;
                newBoardSize.height = uploadImageInfo.height;
            }

            if (newBoardSize.width > FJImageExtenderData.IMAGE_MAX_EXTENDER_DISTANCE) {
                newBoardSize.width = FJImageExtenderData.IMAGE_MAX_EXTENDER_DISTANCE;
                newBoardSize.height = Math.floor(newBoardSize.width / curBoardRatio);
            }

            if (imageRatio > 1) {
                newImageRect.width = newBoardSize.width * 0.7;
                newImageRect.height = newImageRect.width / imageRatio;
            } else {
                newImageRect.height = newBoardSize.height * 0.7;
                newImageRect.width = newImageRect.height * imageRatio;
            }

            if (newImageRect.width > newBoardSize.width) {
                newImageRect.width = newBoardSize.width;
                newImageRect.height = newImageRect.width / imageRatio;
            }

            if (newImageRect.height > newBoardSize.height) {
                newImageRect.height = newBoardSize.height;
                newImageRect.width = newImageRect.height * imageRatio;
            }

            dispatch(
                this.setBoardSizeAction({
                    width: Math.floor(newBoardSize.width),
                    height: Math.floor(newBoardSize.height),
                }),
            );
            dispatch(
                setSliceImageRect({
                    width: newImageRect.width,
                    height: newImageRect.height,
                    x: (newBoardSize.width - newImageRect.width) / 2,
                    y: (newBoardSize.height - newImageRect.height) / 2,
                }),
            );
        };
    },

    /**
     * @desc 设置当前比例
     * @param {{}} ratioData
     * @returns
     */
    setCurRatioNameAction: function (ratioData) {
        return async dispatch => {
            dispatch(setSliceCurRatioName(ratioData.name));
            dispatch(this._fitBoardSizeByCurRatioAction());
        };
    },

    setBoardSizeAction: function (boardSize) {
        return dispatch => {
            dispatch(setSliceBoardSize(boardSize));
        };
    },

    setImageRectAction: function (imageRect) {
        return dispatch => {
            const newImageRect = { ...imageRect };
            dispatch(setSliceImageRect(newImageRect));
        };
    },

    /**
     * @desc 计算扩展数据
     * @returns
     */
    _calcExtenderDataAction: function (viewImageRect, originalImageRect, boardSize) {
        const { width: originalWidth } = originalImageRect;

        const MAX_BORDER_PIX = 3000;
        let scale = Number((originalWidth / viewImageRect.width).toFixed(3));

        const newBoardSize = {
            width: Math.floor(boardSize.width * scale),
            height: Math.floor(boardSize.height * scale),
        };

        if (newBoardSize.width > MAX_BORDER_PIX || newBoardSize.height > MAX_BORDER_PIX) {
            const ratio = boardSize.width / boardSize.height;

            if (ratio >= 1) {
                newBoardSize.width = MAX_BORDER_PIX;
                newBoardSize.height = Math.floor(newBoardSize.width / ratio);
            } else {
                newBoardSize.height = MAX_BORDER_PIX;
                newBoardSize.width = Math.floor(newBoardSize.height * ratio);
            }
        }

        const boardScale = Number((newBoardSize.width / boardSize.width).toFixed(3));

        const newImageRect = {
            width: Math.floor(viewImageRect.width * boardScale),
            height: Math.floor(viewImageRect.height * boardScale),
            x: viewImageRect.x * boardScale,
            y: viewImageRect.y * boardScale,
        };

        if (boardScale === scale) {
            newImageRect.width = originalImageRect.width;
            newImageRect.height = originalImageRect.height;
        }

        const { width, height } = newBoardSize;

        const left = Math.max(Math.floor(newImageRect.x), 0);
        const right = Math.max(Math.floor(width - newImageRect.width - left), 0);
        const top = Math.max(Math.floor(newImageRect.y), 0);
        const bottom = Math.max(Math.floor(height - newImageRect.height - top), 0);

        return {
            left,
            right,
            top,
            bottom,
            newImageRect,
            newBoardSize,
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const { uploadImageInfo, boardSize, imageRect, generateNumber } = getState().imageExtender;
            const { width, height } = boardSize;
            const { creditNumber, freeNumCreation } = getState().common;
            const taskStatus = getState().common.taskStatus;
            const curBoardRatioName = getState().imageExtender.curRatioName;
            f_startGenerateTime = new Date().getTime();
            let isFree = false;

            if (FJUtil.isGeneratingStatus(taskStatus)) return;
            if (!uploadImageInfo || !uploadImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }

            const __errorCallback = failTaskCount => {
                if (!failTaskCount) {
                    dispatch(setSliceCreationListAction([]));
                } else {
                    const creationList = [...getState().common.creationList];
                    const allTaskListLength = creationList.length;

                    for (let i = allTaskListLength - failTaskCount; i < allTaskListLength; i++) {
                        creationList[i].isLoading = false;
                        creationList[i].isReload = true;
                    }
                    dispatch(setSliceCreationListAction(creationList));
                }

                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            };

            const __judgeCanGenerate = async () => {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(
                            FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                            'error',
                        );
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }
                const useCredit = IMAGE_EXTENDER_USE_CREDIT * generateNumber;

                //4.额度判断
                const canFreeCreate = freeNumCreation > 0;
                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            const __getCompressAfterSize = () => {
                const aspectRatio = uploadImageInfo.width / uploadImageInfo.height;

                if (aspectRatio >= 1 && uploadImageInfo.width > MAX_COMPRESS_IMAGE_SIZE) {
                    return {
                        width: MAX_COMPRESS_IMAGE_SIZE,
                        height: MAX_COMPRESS_IMAGE_SIZE / aspectRatio,
                    };
                }

                if (aspectRatio < 1 && uploadImageInfo.height > MAX_COMPRESS_IMAGE_SIZE) {
                    return {
                        width: MAX_COMPRESS_IMAGE_SIZE * aspectRatio,
                        height: MAX_COMPRESS_IMAGE_SIZE,
                    };
                }

                return {
                    width: uploadImageInfo.width,
                    height: uploadImageInfo.height,
                };
            };

            FJUtil.eaLog('image extender generate click', {
                number: generateNumber,
                ratio: curBoardRatioName,
            });

            // 修改状态生成占位符
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: generateNumber,
                width: width,
                height: height,
                type: FJConstant.CREATIONS,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.GENERATIONS));
            dispatch(setSliceIsShowPresetImageBox(false));
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const isCanGenerate = await __judgeCanGenerate();

            if (!isCanGenerate) {
                __errorCallback();
                return;
            }
            // 1. 压缩图片
            const imageBlob = await FJCompressedImageStore.simpleCompressImage(uploadImageInfo.src);

            const compressAfterSize = __getCompressAfterSize();

            // 2. 上传图片到 s3
            const id = await FJUtil.hashEncode(imageBlob);
            if (!id) return;
            const key = FJConfig.originalImageKey + `${id}.png`;
            const result = await FJImageStore.upLoadFileToS3Async(imageBlob, key);

            if (!result) {
                // 上传失败
                FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-failed'), 'error');
                return;
            }

            const { left, right, top, bottom, newImageRect } = this._calcExtenderDataAction(
                imageRect,
                compressAfterSize,
                boardSize,
            );

            // 4. 生成图片
            const _request = async () => {
                // 目标图与原图的缩放比例
                const scale = Number((newImageRect.width / compressAfterSize.width).toFixed(3));
                return await FJNetworkStore.imageExtender(
                    FJS3Config.S3_SERVER_HOST + key,
                    left,
                    right,
                    top,
                    bottom,
                    scale,
                );
            };

            const eventIdList = [];

            for (let i = 0; i < generateNumber; i++) {
                const eventId = await FJActionCommon.createRequestTask(_request, dispatch);
                eventId && eventIdList.push(eventId);
            }
            if (!eventIdList.length) {
                __errorCallback();
                return;
            }
            FJUtil.updateAllCreditInfo();
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

            // 3. 轮询任务状态
            const callback = data => {
                const { type } = data;

                if (type === FJConstant.ERROR) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                    __errorCallback();
                }

                if (type === FJConstant.SUCCESS) {
                    let endTime = new Date().getTime();
                    const generatingDuration = FJUtil.getTimeDiff(f_startGenerateTime, endTime);

                    FJUtil.eaLog('image extender generate success', {
                        number: generateNumber,
                        ratio: curBoardRatioName,
                        'generating duration': generatingDuration,
                        'resolution:': `${width} * ${height}`,
                    });
                    FJUtil.eaLog('ai tool generate success', {
                        tool: FJUtil.getToolName(),
                        'credit&free': isFree ? 'free' : 'credit',
                    });
                }

                // 将失败的任务更改为失败状态
                if (type === FJConstant.SUCCESS && data.failTaskCount > 0) {
                    __errorCallback(data.failTaskCount);
                }
            };

            dispatch(
                FJActionCommon.pollingTaskAction(eventIdList, {
                    callback,
                    autoDefaultTaskStatus: !FJUtil.isMobile(),
                    isUseFree: isFree,
                }),
            );
        };
    },

    /**
     * @desc 修改生成数量
     * @param {number} newGenerateNumber
     * @returns
     */
    changeGenerateNumberAction: function (newGenerateNumber) {
        return (dispatch, getState) => {
            const { generateNumber } = getState().imageExtender;

            if (generateNumber === newGenerateNumber) return;

            const isLogin = FJUtil.isLogin();

            if (isLogin) {
                const { creditNumber, freeNumCreation } = getState().common;

                if (
                    creditNumber < IMAGE_EXTENDER_USE_CREDIT * newGenerateNumber &&
                    (freeNumCreation === 0 || newGenerateNumber > 1)
                ) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }

            dispatch(setSliceGenerateNumber(newGenerateNumber));
        };
    },

    initImageExtenderDataAction: function () {
        return async dispatch => {
            dispatch(this._loadImageExtenderParamsAction());
        };
    },

    /**
     * @desc 文生图带参数访问加载
     * @returns
     */
    _loadImageExtenderParamsAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                if (!window.isEditPage) {
                    const url = location.origin + location.pathname;
                    FJUtil.changeLocation(url);
                }
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadImageAction(file, true));
                } else if (avator) {
                    try {
                        // Url 转 blob
                        const blob = await FJFileHandleUtil.downloadImage(avator);
                        // blob 转 file
                        const file = new File([blob], 'avator', { type: blob.type });
                        dispatch(this.uploadImageAction(file, true));
                    } catch (error) {
                        FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    }
                }
            }
        };
    },
};

export default FJActionImageExtender;
